import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type ListPreviewRootProps = {
  children: ReactNode;
  className?: string;
};

function ListPreviewRoot({ children, className }: ListPreviewRootProps) {
  const mergedClasses = twMerge(
    "flex flex-col gap-3 p-4 border border-gray-200 rounded-md bg-gray-50 w-full max-w-full overflow-x-auto",
    className,
  );
  return <div className={mergedClasses}>{children}</div>;
}

export default ListPreviewRoot;
